// extracted by mini-css-extract-plugin
export default {"div":"Footer_div__4RApz","social":"Footer_social__WSX7i","icon":"Footer_icon__jJxan","a":"Footer_a__b3Ct1","fot":"Footer_fot__Ex4Dv"};